const redirToProjectDetailsIfProject = function(
  projectId: string,
  projectStatus: string,
  assessorStatus: string,
  mode: string,
  tasksView: boolean,
  device: string,
  userRole: string,
  router: any,
  invokingComponent: any,
): void {
  if (mode !== 'projects') return;

  const statusesOfOngoingOrCompletedProject = ['confirmed', 'cancelled', 'completed'];
  const notDesktopDashboard = !tasksView || device === 'mobile';
  const assessorCanAccessOngoingOrCompletedProject =
    statusesOfOngoingOrCompletedProject.includes(projectStatus) && assessorStatus === 'confirmed';

  if (
    (projectStatus === 'pending' || projectStatus === 'accepted') &&
    assessorStatus === 'invited' &&
    notDesktopDashboard
  ) {
    router.push({ path: '/assessor-request-confirmation', query: { id: projectId } });
  } else if (projectStatus === 'accepted' && assessorStatus === 'accepted') {
    invokingComponent.$notify({
      title: invokingComponent.$t('theClientHasBeenInformed') as string,
      message: invokingComponent.$t('clientInformedDesc') as string,
      type: 'info',
      duration: 10000,
      offset: 120,
    });
  } else if (assessorCanAccessOngoingOrCompletedProject && notDesktopDashboard) {
    router.push({ path: '/assessment-request', query: { id: projectId } });
  } else if (userRole === 'client' && notDesktopDashboard) {
    router.push({
      path: '/assessment-request',
      query: { id: projectId, isInClientProjects: 'true' },
    });
  }
};

export default redirToProjectDetailsIfProject;
